const enrollmentResults = ['ENROLLMENT_SUCCESS', 'ENROLLMENT_FAILURE', 'ENROLLMENT_TIMEOUT'] as const;
type EnrollmentResult = typeof enrollmentResults[number];

export const enrollmentResultValueFormatter = (value: EnrollmentResult) => {
  switch (value) {
    case 'ENROLLMENT_SUCCESS':
      return 'Enrollment success';
    case 'ENROLLMENT_FAILURE':
      return 'Enrollment failure';
    case 'ENROLLMENT_TIMEOUT':
      return 'Enrollment timeout';
    default:
      return value;
  }
};
